import Image from "next/image";
import React from "react";
import styled from "styled-components";

const ButtonStyling = styled.a`
    cursor: pointer;
    transition: filter 300ms;

    &:hover {
        filter: saturate(0.5);
    }
`;

interface Props {
    clubSlug: string;
}

export const MollieConnectButton = ({ clubSlug }: Props) => {
    return (
        <a href={`${process.env.NEXT_PUBLIC_BACKEND_HOST}connect/${clubSlug}`} target="_blank">
            <div className="tw-h-[32px] tw-relative tw-aspect-[40/9]">
                <Image
                    src="/images/mollie/connect/Button@2x.png"
                    layout="fill"
                    objectFit="cover"
                    alt="MollieConnect button image"
                />
            </div>
        </a>
    );
};
